var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { GlobalFilter } from "./GlobalFilter";
import React, { useContext } from "react";
import { TranslationContext } from "../../hooks/useTranslationContext";
import { isEmpty } from "underscore";
export function SearchableTable(_a) {
    var tableProps = _a.tableProps, visibleColumns = _a.visibleColumns, globalFilter = _a.globalFilter, setGlobalFilter = _a.setGlobalFilter, headerGroups = _a.headerGroups, getTableBodyProps = _a.getTableBodyProps, prepareRow = _a.prepareRow, page = _a.page, rows = _a.rows, loading = _a.loading, emptyText = _a.emptyText;
    var t = useContext(TranslationContext);
    return (React.createElement("table", __assign({}, tableProps),
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", { key: "globalfilter-cont", colSpan: visibleColumns ? visibleColumns.length : 1, style: {
                        textAlign: 'left',
                    } }, setGlobalFilter &&
                    (React.createElement(GlobalFilter, { t: t, globalFilter: globalFilter, setGlobalFilter: setGlobalFilter })))),
            headerGroups.map(function (headerGroup, headGroupIdx) { return (React.createElement("tr", __assign({ key: "headergrp-" + headGroupIdx }, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column) { return (React.createElement("th", { key: column.id },
                React.createElement("span", __assign({}, column.getHeaderProps(column.getSortByToggleProps())),
                    column.render("Header"),
                    column.isSorted
                        ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                        : ""),
                React.createElement("div", null, column.Filter ? column.render('Filter') : null))); }))); })),
        React.createElement("tbody", __assign({}, getTableBodyProps()),
            loading ? (React.createElement("tr", null,
                React.createElement("td", { className: "loader-element", colSpan: 100 },
                    React.createElement("div", { className: "loading loading-lg" })))) :
                isEmpty(rows) && isEmpty(page) && emptyText && !loading && (React.createElement("tr", null,
                    React.createElement("td", { colSpan: 100 }, emptyText))),
            !loading && page.map(function (row, i) {
                prepareRow(row);
                return (React.createElement("tr", __assign({ key: "row-" + i }, row.getRowProps()), row.cells.map(function (cell, cellIdx) {
                    return React.createElement("td", __assign({ key: "row-" + i + "-td" + cellIdx }, cell.getCellProps({ className: cell.column.id })), cell.render('Cell', { key: "row-" + i + "-cell" + cellIdx }));
                })));
            }))));
}
